import React, { useState, useEffect, useRef } from "react";
import {
  ActionIcon,
  Avatar,
  Badge,
  Box,
  Button,
  Center,
  Collapse,
  FileInput,
  Flex,
  Grid,
  Group,
  Image,
  Indicator,
  Input,
  Loader,
  Modal,
  Skeleton,
  Text,
  TextInput,
} from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faL, faPhone, faVideo } from "@fortawesome/free-solid-svg-icons";
// import { Grid, MessageSquare } from "react-feather";
import personSvg from "../assets/img/fluent_bot-24-filled.svg";
import arrowIcon from "../assets/img/sendButton.svg";
import clipSvg from "../assets/img/clipSvg.svg";
import { useMedplum } from "@medplum/react";
import { useMediaQuery } from "@mantine/hooks";

import {
  chatCommunicationsBot,
  createSubscriptionsToken,
  fetchPreviousMessages,
  getMimeTypeFromDataUrl,
  getSubscriptionToken,
  handleFileDownload,
  isEffectiveTimeLessThanTenMinutes,
  handleOtherFileDownload,
  onSend,
  vitalLogo,
} from "../pages/Patient/PatientDetails/ChatServices";
import chatNotFoundSvg from "../assets/img/Chat not found.svg";
import {
  IconFile,
  IconFileTypeXml,
  IconJpg,
  IconPaperclip,
  IconPdf,
  IconUpload,
} from "@tabler/icons-react";
import { useDisclosure } from "@mantine/hooks";
import uploadIcon from "../assets/img/uploadIcon.svg";
import deleteIcon from "../assets/img/deleteIcon.svg";
import fileLogo from "../assets/img/fileLogo.svg";
import { fileToBase64 } from "../pages/HomePage.utils";
import timer from "../assets/img/timernew.svg";

import {
  calculateTimeDifference,
  circularPlatformLogo,
  getClientTypes,
} from "../utils";
import heartRateLogo from "../assets/img/HeartRatenew.svg";
import { MessageSquare } from "react-feather";
import { FileViewer } from "./FileViewer";
import pdfSvg from "../assets/img/pdfFile.svg";
import xmlSvg from "../assets/img/xmlFile.svg";
import imageSvg from "../assets/img/imagefile.svg";
import rtfSvg from "../assets/img/rtfFile.svg";

interface Message {
  id: string;
  text: string;
  date: string;
  sender: string;
  timestamp: string;
  avatar: string;
  person: string;
  content: any;
}

export interface chatProps {
  patientId: string;
  practiotnerId: String;
  name: any;
  selectedClients?: any;
}
function ChatWidget({
  patientId,
  practiotnerId,
  name,
  selectedClients,
}: chatProps): JSX.Element {
  const [messages, setMessages] = useState<Message[]>([]);
  const [newMessage, setNewMessage] = useState<string>("");
  const [loading, setloading] = useState<boolean>(false);
  const [isSending, setSending] = useState<any>(false);
  const [opened, { toggle }] = useDisclosure(false);

  // const [value, setValue] = useState<File[]>([]);
  const [viewFile, setViewFile] = useState<boolean>(false);
  const [documentModal, setDocumentModal] = useState(false);
  const [file, setFile] = useState<any>();
  const [title, settitle] = useState<string>();
  const [fileType, setFileType] = useState<string>();
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [patientDetails, setPatientDetails] = useState<any>({});
  const [wearableDevie, setwearableDevie] = useState({});
  const [viewVitals, setViewVitals] = useState<boolean>(false);
  // // const [selectedClient, setSelectedClient] = useState<any>({
  //   name: "Google Fit",
  // });
  const [clientsOptions, setClientsOptions] = useState<any>([]);
  const [repeater, setRepeater] = useState(1);
  const [vitalData, setVitalData] = useState<any>();
  const [observations, setObservations] = useState<any>([]);
  const [blob, setBlob] = useState<any>();
  const [downloadType, setDownloadType] = useState<any>();
  const [downloadName, setDownloadName] = useState<any>();
  const [vitalsLoading, setVitalsLoading] = useState<any>(false);

  const [url, setUrl] = useState<any>();
  const [documentData, setDocumentData] = useState<any>();

  const messagesContainerRef = useRef<HTMLDivElement>(null);

  const medplum = useMedplum();
  const [subscriptionIds, setSubscriptionIds] = useState<string[]>([]);
  const ws = useRef<WebSocket | null>(null);
  const WS_URL = "wss://api-stage.healthconnect.systems/ws/subscriptions-r4";
  let apitimeoutId: any;
  const isSmallHeight = useMediaQuery("(max-height: 850px)");

  useEffect(() => {
    setVitalsLoading(true);

    const filteredObjects = observations.reduce((acc: any, curr: any) => {
      const codeText = curr?.code?.text || curr?.valueQuantity?.unit;
      if (codeText && !acc[codeText]) {
        acc[codeText] = curr;
      }
      return acc;
    }, {});
    setVitalData(filteredObjects);
    setVitalsLoading(false);
  }, [observations]);

  useEffect(() => {
    setloading(true);
    fetchPreviousMessages(medplum, practiotnerId, patientId).then((res) => {
      setMessages(res);
      setloading(false);
    });
  }, [patientId, practiotnerId]);

  // useEffect(() => {
  //   getPatientDetails();
  // }, []);

  const vitals =
    (vitalData ? Object.values(vitalData) : [])?.map((vital: any) => {
      const nameWithoutSpaces = (
        vital?.code?.text || vital?.valueQuantity?.unit
      )?.replace(/\s/g, "");

      return {
        image: vitalLogo[nameWithoutSpaces?.toLowerCase()] || "",
        title:
          vital?.code?.text === "Temp"
            ? "Temperature"
            : vital?.code?.text === "hr_max"
              ? "Heart Rate"
              : vital?.valueQuantity?.unit === "steps"
                ? "Steps"
                : vital?.code?.text === "Oxygen Saturation by Pulse Oximetry"
                  ? "Oxygen Saturation"
                  : vital?.code?.text || "",
        value:
          vital?.code?.text === "Blood Pressure"
            ? vital?.component?.[1]?.valueQuantity?.value
            : vital?.code?.text === "Cycling"
              ? vital?.valueQuantity?.value > 1000
                ? vital?.valueQuantity?.value / 1000
                : vital?.valueQuantity?.value
              : vital?.valueQuantity?.value || "-",
        unit:
          vital?.code?.text === "Blood Pressure"
            ? vital?.component?.[1]?.valueQuantity?.unit
            : vital?.code?.text === "Cycling"
              ? vital?.valueQuantity?.value > 1000
                ? "km"
                : vital?.valueQuantity?.unit
              : (vital?.valueQuantity?.unit === "beats/minute"
                ? "bpm"
                : vital?.valueQuantity?.unit) || "",

        effectiveDateTime: vital?.effectiveDateTime || "",
      };
    }) || [];
  useEffect(() => {
    setVitalsLoading(true);

    getDevices();
  }, [viewVitals]);
  useEffect(() => {
    {
      viewVitals && getDevices();
      apitimeoutId = setTimeout(() => setRepeater(repeater + 1), 5000);
    }
  }, [repeater]);

  const getPatientDetails = () => {
    medplum
      .searchResources("Patient", `identifier=${patientId}`)
      .then((res: any) => {
        if (res[0]) {
          setPatientDetails(res[0]);
        } else {
          medplum.readResource("Patient", patientId).then((res: any) => {
            setPatientDetails(res);
          });
        }
      });
  };
  const getDevices = async () => {
    const devices = await medplum.searchResources(
      "Device",
      `patient=Patient/${patientId}`
    );

    const clients = await getClients(devices);

    const googleFitClient = clients?.filter((client) =>
      selectedClients?.id
        ? client?.id === selectedClients?.id
        : client.name === selectedClients?.name
    ) as any;

    const device = devices.filter(
      (device) => device?.deviceName?.[0]?.name == googleFitClient[0]?.id
    )[0];

    setwearableDevie(device);
    if (device) {
      getObservationData(device);
    }
  };
  const getObservationData = async (device: any) => {
    const lonicCodes = [
      "85354-9",
      "2339-0",
      "8867-4",
      "59408-5",
      "8302-2",
      "29463-7",
      "41982-0",
      "41982-0",
      "41950-7",
      "LP416428-3",
      "73985-4",
      "20448-7",
    ];
    let observationBuffer: any = [];

    const promises = lonicCodes.map((code) =>
      medplum
        .searchResources(
          "Observation",
          `code=${code}&patient=${patientId}&device=Device/${device?.id}&_sort=-date`
        )
        .then((res) => {
          observationBuffer = [...observationBuffer, ...res];
          setVitalsLoading(false);
        })
        .finally(() => {
          //  setIsLoading(false);
          setObservations(observationBuffer);
          setVitalsLoading(false);
        })
    );

    Promise.all(promises).catch((error) => {
      console.error(error);
      clearTimeout(apitimeoutId); //settimeout clear
      //  setIsLoading(false);
    });
  };
  const getClients = async (devices: any) => {
    const res = await medplum.searchResources(
      "ClientApplication",
      `_count=100`
    );
    const tempNameArr: any = [];
    const tempIdArr: any = [];
    const selectedClientArr: any = [];
    devices.forEach((device: any) => {
      tempNameArr.push(device?.deviceName?.[0]?.name);
      tempIdArr.push(device?.id);
    });
    const newTempArr = [];
    for (let client of res) {
      let tempClient: any = { ...client };
      let clientId = client.id;
      if (tempNameArr.includes(clientId)) {
        let deviceIdx = tempNameArr.indexOf(clientId);
        tempClient["device"] = tempNameArr[deviceIdx];
        tempClient["deviceId"] = tempIdArr[deviceIdx];

        selectedClientArr.push(tempClient);
      }
      const clientTypes = getClientTypes(tempClient?.meta?.extension);
      if (clientTypes?.includes("Wearable")) {
        newTempArr.push(tempClient);
      }
    }

    setClientsOptions(newTempArr);
    return res;
  };
  const handleAttachFile = () => {
    setDocumentModal(false);
  };
  const handleDeleteFile = () => {
    setSelectedFile(null);
    setFileType("");
  };
  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    const file = event.dataTransfer.files[0];

    fileToBase64(file).then((res) => {
      setFile(res as any);

      const filetype = getMimeTypeFromDataUrl(res);
      setFileType(filetype);
      setSelectedFile(file);
    });
  };
  const handleFileInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      // setSelectedFile(file);
      fileToBase64(file).then((res) => {
        setFile(res as any);

        const filetype = getMimeTypeFromDataUrl(res);
        setFileType(filetype);
        setSelectedFile(file);
      });
    }
  };

  useEffect(() => {
    const scrollToBottom = () => {
      if (messagesContainerRef.current) {
        messagesContainerRef.current.scrollTo({
          top: messagesContainerRef.current.scrollHeight,
          behavior: "smooth",
        });
      }
    };

    scrollToBottom();
  }, [messages]);
  const handleUploadAreaClick = () => {
    const fileInput = document.getElementById("fileInput");
    if (fileInput) {
      fileInput.click();
    }
  };
  let lastDate = "";

  useEffect(() => {
    const initializeWebSocket = async () => {
      ws.current = new WebSocket(WS_URL);

      ws.current.onopen = async () => {
        const ids = await createSubscriptionsToken(
          medplum,
          patientId,
          practiotnerId
        );
        const tokens = await getSubscriptionToken(ids, medplum);

        tokens.forEach((token) => {
          ws.current?.send(
            JSON.stringify({ type: "bind-with-token", payload: { token } })
          );
        });
      };

      ws.current.onmessage = (event) => {
        try {
          const messageReceived = JSON.parse(event.data);
          if (messageReceived.entry && messageReceived.entry.length > 0) {
            messageReceived.entry.forEach((entry: any, index: any) => { });
          }
          const communicationEntry = messageReceived.entry.find(
            (entry: any) => entry.resource.resourceType === "Communication"
          );

          if (communicationEntry) {
            const communication = communicationEntry.resource;
            if (communication.payload[0]?.contentString) {
              const newMessage: Message = {
                id: communication.id,
                text:
                  communication.payload[0].contentString === "{EMPTY}"
                    ? ""
                    : communication.payload[0].contentString,
                date: new Date(communication.sent).toLocaleDateString(),
                content: communication?.payload?.[1]?.contentAttachment
                  ? communication.payload[1].contentAttachment
                  : communication?.payload?.[0]?.contentAttachment,

                sender: communication.sender.reference,
                timestamp: new Date(communication.sent).toLocaleTimeString(),
                avatar: communication.sender.reference.includes("Practitioner")
                  ? "https://ui-avatars.com/api/?name=Practitioner"
                  : "https://t3.ftcdn.net/jpg/02/17/64/02/360_F_217640276_uNPwftAgKhHALaVUgj6SFv5crXWsVAuG.jpg",
                person: communication.sender.reference.includes("Practitioner")
                  ? "sender"
                  : "receiver",
              };
              setMessages((prevMessages) => [...prevMessages, newMessage]);
            }
          }
        } catch (error) {
          console.error("Error parsing WebSocket message:", error);
        }
      };

      ws.current.onclose = () => { };

      ws.current.onerror = (error) => {
        console.error("WebSocket error:", error);
      };
    };

    initializeWebSocket();

    return () => {
      if (ws.current) {
        ws.current.close();
      }
    };
  }, []);

  const reverse = messages.reverse();

  const handleSendMessage = () => {
    if (file && !newMessage && fileType && title) {
      onSend(
        "{EMPTY}",
        practiotnerId,
        patientId,
        medplum,
        file,
        title,
        fileType
      ).then(() => {
        resetForm();
      });
    } else if (newMessage && !file && !fileType && !title) {
      onSend(newMessage, practiotnerId, patientId, medplum).then(() => {
        resetForm();
      });
    } else if (newMessage && file && fileType && title) {
      onSend(
        newMessage,
        practiotnerId,
        patientId,
        medplum,
        file,
        title,
        fileType
      ).then(() => {
        resetForm();
      });
    }

    setSending(false);
  };

  const resetForm = () => {
    setNewMessage("");
    setFile(null);
    setFileType("");
    settitle("");
    setSelectedFile(null);
  };
  const handleViewfile = (data: any, name: any, type: any) => {
    setDownloadType(type);
    setDocumentData(data);
    setDownloadName(name);

    const file = handleFileDownload(data, name, type);
    if (file?.includes("http")) {
      setViewFile(true);

      setUrl(file);
    }
    if (file?.includes("rtf" || "xml")) {
      setViewFile(false);

      handleOtherFileDownload(data, name, type);
    }
  };
  const downloadViewFile = () => {
    handleOtherFileDownload(documentData, downloadName, downloadType);
  };

  return (
    <div style={styles.chatContainer}>
      <Box style={styles.chatHeader}>
        <Avatar color="black" radius="xl">
          {name.split(" ").length > 1
            ? name.split(" ")[0][0].toUpperCase() +
            name.split(" ")[1][0].toUpperCase()
            : name.slice(0, 2).toUpperCase()}
        </Avatar>
        <Text fw={600} fs={"25px"} color="white">
          {name}
        </Text>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <Avatar size="sm" color="black" radius="xl">
            <FontAwesomeIcon icon={faPhone} style={styles.icon} />
          </Avatar>
          <Avatar size="sm" color="black" radius="xl">
            <FontAwesomeIcon icon={faVideo} style={styles.icon} />
          </Avatar>
        </div>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          // gap: "8px",
          boxShadow: "0 2px 1px -1px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Text
            sx={{
              fontWeight: 600,
              fontSize: "12px",
              lineHeight: "21px",
              color: "#1B75BC",
              cursor: "pointer",
            }}
            mb={3}
            onClick={() => {
              setViewVitals((prevState) => !prevState);
            }}
          >
            {viewVitals ? "Hide Vitals" : "View Vitals"}
          </Text>
        </Box>
      </Box>
      {viewVitals && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            overflowX: "auto",
            // backgroundColor:"red",
            // overflow:"hidden",
            gap: "8px",
            padding: "8px",
            scrollBehavior: "smooth",
            "&::-webkit-scrollbar": {
              height: "2px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
              borderRadius: "10px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
            "&::-webkit-scrollbar-track": {
              background: "#f1f1f1",
            },
          }}
        >
          {vitals.map((vital: any, index: number) => (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: "8px",
                height: "56px",
              }}
            >
              {" "}
              {vitalsLoading ? (
                <>
                  <Box ml={10} sx={{ display: "flex", flexDirection: "row" }}>
                    <Skeleton height={40} circle mb="lg" />
                  </Box>
                </>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    border: "1px solid #C9CDD3",
                    justifyContent: "space-between",
                    padding: "8px 12px 8px 12px",
                    flexDirection: "row",
                    // gap: "8px",
                    minWidth: "140px",
                  }}
                  style={
                    (vital.title === "Heart Rate" && vital.value > 100) ||
                      (vital.title === "Blood Pressure" && vital.value > 160) ||
                      (vital.title === "Oxygen Saturation" && vital.value < 85) ||
                      (vital.title === "Spo2" && vital.value < 85) ||
                      (vital.title === "Weight" && vital.value > 150) ||
                      (vital.title === "Body Fat Percentage" &&
                        vital.value > 40) ||
                      (vital.title === "Body Temperature" && vital.value > 38) ||
                      (vital.title === "BMI" && vital.value > 30) ||
                      (vital.title === "Blood Glucose Level" && vital.value > 180)
                      ? styles.alertvitalCard
                      : styles.vitalCard
                  }
                >
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    <img
                      src={vital.image}
                      style={{
                        display: "flex",
                        alignItems: "flex-end",
                        height: "40px",
                        width: "40px",
                      }}
                    />
                    {/* <Text style={styles.vitalTitle}>{vital.title}</Text> */}
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "4px",
                        marginRight: "2px",
                      }}
                    >
                      <Text
                        style={styles.vitalValueText}
                        color={
                          (vital.title === "Heart Rate" && vital.value > 100) ||
                            (vital.title === "Blood Pressure" &&
                              vital.value > 160) ||
                            (vital.title === "Oxygen Saturation" &&
                              vital.value < 85) ||
                            (vital.title === "Spo2" && vital.value < 85) ||
                            (vital.title === "Weight" && vital.value > 150) ||
                            (vital.title === "Body Fat Percentage" &&
                              vital.value > 40) ||
                            (vital.title === "Body Temperature" &&
                              vital.value > 38) ||
                            (vital.title === "BMI" && vital.value > 30) ||
                            (vital.title === "Blood Glucose Level" &&
                              vital.value > 180)
                            ? "Red"
                            : "#262930"
                        }
                      >
                        {vital?.value && ['Heart Rate', 'Steps', 'Blood Pressure'].includes(vital?.title)
                          ? vital?.value?.toFixed(0)
                          : vital?.value?.toFixed(1)}
                      </Text>
                      <Text style={styles.vitalUnit}>{vital.unit}</Text>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-end",
                        gap: "3px",
                      }}
                    >
                      <Text
                        sx={{
                          fontWeight: 400,
                          fontSize: "10px",
                          lineHeight: "20px",
                          color: "#0570DE",
                        }}
                        style={{
                          color: isEffectiveTimeLessThanTenMinutes(
                            vital.effectiveDateTime
                          ),
                        }}
                      >
                        {calculateTimeDifference(vital.effectiveDateTime)}
                      </Text>{" "}
                      {calculateTimeDifference(vital.effectiveDateTime) ===
                        "Just now" ? (
                        ""
                      ) : (
                        <Text
                          color={isEffectiveTimeLessThanTenMinutes(
                            vital.effectiveDateTime
                          )}
                          sx={{
                            fontWeight: 500,
                            fontSize: "10px",
                            lineHeight: "20px",
                          }}
                          mr={2}
                        >
                          {" "}
                          ago
                        </Text>
                      )}
                    </Box>
                  </Box>
                </Box>
              )}
            </Box>
          ))}
        </Box>
      )}

      <Box
        ref={messagesContainerRef}
        style={styles.messagesContainer}
        sx={{
          overflowY: "auto",
          maxHeight: isSmallHeight ? "300px" : "400px", // Adjust heights as needed
          minHeight: isSmallHeight ? "300px" : "400px",
          scrollBehavior: "smooth",
          "&::-webkit-scrollbar": {
            width: "3px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#888",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "#555",
          },
          "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
          },
        }}
      >
        {!loading && messages.length <= 0 && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "90px",
              padding: "20px",
              flexDirection: "column",
            }}
          >
            <img src={chatNotFoundSvg} alt="No chats availabel" />
            <Text fs={"30px"} fw={800} color="#7e7e81" pt={"20px"}>
              Please send a message to start the chat.
            </Text>
          </Box>
        )}{" "}
        {loading ? (
          <Center
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <Loader variant="dots" />
          </Center>
        ) : (
          <>
            {messages.reverse().map((msg, index) => {
              const showDate = msg.date !== lastDate;
              if (showDate) {
                lastDate = msg.date;
              }

              return (
                <React.Fragment key={msg.id}>
                  {showDate && (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "10px",
                      }}
                    >
                      <Text>{msg.date}</Text>
                    </Box>
                  )}
                  <Box
                    key={msg.id}
                    sx={{
                      display: "flex",
                      justifyContent:
                        msg.person !== "receiver" ? "flex-end" : "flex-start",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-end",
                        paddingTop: "12px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          backgroundColor:
                            msg.person !== "receiver" ? "#1B75BC" : "#F1F9FF",
                          borderRadius: "12px",
                          padding: "15px 15px 10px 15px",
                          maxWidth: "290px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Text
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            fontWeight: 500,
                            fontSize: "14px",
                            lineHeight: "20px",
                            color:
                              msg.person !== "receiver" ? "white" : "black",
                            flexWrap: "wrap",
                            wordBreak: "normal",
                          }}
                        >
                          {msg?.content ? (
                            <Box
                              mb={5}
                              sx={{
                                border: "1px solid grey",
                                padding: "4px",
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer",
                                borderRadius: "8px",
                              }}
                              onClick={() =>
                                handleViewfile(
                                  msg?.content?.data,
                                  msg?.content?.title,
                                  msg?.content?.contentType
                                )
                              }
                            >
                              {msg?.content?.contentType.includes("pdf") && (
                                <img
                                  src={pdfSvg}
                                  style={{
                                    height: "15px",
                                    width: "15px",
                                    marginRight: "4px",
                                    cursor: "pointer",
                                  }}
                                />
                              )}
                              {msg?.content?.contentType.includes(
                                "image" || "png" || "jpeg" || "jpeg"
                              ) && (
                                  <img
                                    src={imageSvg}
                                    style={{
                                      height: "20px",
                                      width: "20px",
                                      marginRight: "4px",
                                      cursor: "pointer",
                                    }}
                                  />
                                )}
                              {msg?.content?.contentType.includes("xml") && (
                                <img
                                  src={xmlSvg}
                                  style={{
                                    height: "20px",
                                    width: "20px",
                                    marginRight: "4px",
                                    cursor: "pointer",
                                  }}
                                />
                              )}
                              {msg?.content?.contentType.includes("rtf") && (
                                <img
                                  src={rtfSvg}
                                  style={{
                                    marginRight: "4px",
                                    cursor: "pointer",
                                  }}
                                />
                              )}

                              <Text sx={{}}> {msg?.content?.title}</Text>
                            </Box>
                          ) : (
                            ""
                          )}{" "}
                          {msg.text}
                        </Text>
                        <Text
                          sx={{
                            display: "flex",
                            justifyContent:
                              msg.person !== "receiver"
                                ? "flex-end"
                                : "flex-start",
                            fontWeight: 500,
                            fontSize: "12px",
                            lineHeight: "20px",
                            color:
                              msg.person !== "receiver" ? "white" : "black",
                            paddingTop: "6px",
                          }}
                        >
                          {msg.timestamp.split(":").slice(0, 2).join(":")}
                        </Text>
                      </Box>
                      <Box
                        sx={{
                          paddingTop: "8px",
                          display: "flex",
                          justifyContent:
                            msg.person !== "receiver"
                              ? "flex-end"
                              : "flex-start",
                        }}
                      >
                        {msg.person === "receiver" ? (
                          <Avatar color="black" radius="xl">
                            {name.split(" ").length > 1
                              ? name.split(" ")[0][0].toUpperCase() +
                              name.split(" ")[1][0].toUpperCase()
                              : name.slice(0, 2).toUpperCase()}
                          </Avatar>
                        ) : (
                          <img src={personSvg} alt="person" />
                        )}
                      </Box>
                    </Box>
                  </Box>
                </React.Fragment>
              );
            })}
          </>
        )}
      </Box>
      <Box style={styles.inputContainer}>
        <Input
          type="text"
          style={styles.input}
          placeholder="Type a message"
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          size="md"
          onKeyDown={(e) => {
            if (e.key === "Enter" && newMessage.trim() !== "") {
              handleSendMessage();
            }
          }}
        />
        <Indicator
          inline
          color="red"
          disabled={!selectedFile}
          label="1"
          size={16}
        >
          <Button
            size="md"
            variant="unstyled"
            bg="#F1F9FF"
            onClick={() => {
              setDocumentModal(true);
            }}
            style={styles.sendButton}
          >
            <Box>
              <img src={clipSvg} />{" "}
            </Box>
          </Button>
        </Indicator>

        <Button
          size="md"
          variant="outline"
          onClick={handleSendMessage}
          style={styles.sendButton}
          bg="#F1F9FF"
        >
          {isSending ? (
            <Box>
              <Loader size={"sm"} />
            </Box>
          ) : (
            <img src={arrowIcon} alt="Send" />
          )}
        </Button>
      </Box>
      {viewFile && (
        <FileViewer
          fileData={blob}
          url={url}
          open={viewFile}
          fileType={"pdf"}
          close={() => {
            setViewFile(false);
          }}
          handleDowload={downloadViewFile as any}
        />
      )}
      <Modal
        opened={documentModal}
        onClose={() => {
          setDocumentModal(false);
        }}
        centered
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <Box sx={{ display: "flex", flexDirection: "row", gap: "20px" }}>
            <Box>
              <Text mb={8}>Document Title</Text>
              <TextInput
                value={title}
                placeholder="Document Title"
                onChange={(event) => settitle(event.currentTarget.value)}
              />
            </Box>
            <Box>
              <Text mb={8}>Document Type</Text>
              <TextInput
                value={fileType ? fileType?.split("/")[1].toUpperCase() : ""}
                disabled
                placeholder="File Type"
              />
            </Box>
          </Box>
          <Box>
            <Text mb={8}>
              {selectedFile ? "Uploaded File" : "Upload Your File"}
            </Text>
            <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {selectedFile ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #E5E5E5",
                    padding: "16px 20px",
                    borderRadius: "8px",
                    marginBottom: "50px",
                    width: "100%",
                  }}
                >
                  <img
                    src={fileLogo}
                    alt="file Logo"
                    style={{
                      width: "50px",
                      height: "50px",
                      marginRight: "16px",
                    }}
                  />
                  <Text
                    sx={{
                      fontSize: "14px",
                      fontWeight: 400,
                      lineHeight: "22px",
                      textAlign: "left",
                      color: "#474E5B",
                    }}
                  >
                    {selectedFile.name}
                  </Text>
                  <ActionIcon
                    variant="link"
                    color="red"
                    onClick={handleDeleteFile}
                    style={{ marginLeft: "auto" }}
                  >
                    <img src={deleteIcon} alt="delete icon" />
                  </ActionIcon>
                </Box>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "40px",
                    height: "140px",
                    borderStyle: "dashed",
                    borderWidth: "1px",
                    borderColor: "#E5E5E5",
                    width: "100%",
                  }}
                  onClick={handleUploadAreaClick}
                  onDrop={handleDrop}
                  onDragOver={(e) => e.preventDefault()}
                >
                  <img
                    src={uploadIcon}
                    style={{ width: "24px", height: "24px" }}
                    alt="Upload Icon"
                  />
                  <Text
                    sx={{
                      fontSize: "14px",
                      fontWeight: 400,
                      lineHeight: "22px",
                      textAlign: "left",
                      color: "#474E5B",
                    }}
                  >
                    Drag and drop file or click to browse
                  </Text>
                  <input
                    type="file"
                    accept=".xml,.rtf,.pdf,.doc,.docx,.txt,.csv,.jpg,.jpeg,.png,.gif,.bmp,.webp"
                    onChange={handleFileInput}
                    style={{ display: "none" }}
                    id="fileInput"
                  />
                </Box>
              )}
            </Box>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={handleAttachFile}
              leftIcon={<IconPaperclip size={16} />}
            >
              Attach file
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
const styles = {
  chatContainer: {
    width: "450px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column" as "column",
    position: "fixed" as "fixed",
    bottom: "100px",
    right: "40px",
    backgroundColor: "#fff",
    gap: "4px",
  },
  vitalTitle: {
    fontWeight: 500,
    fontSize: "10px",
    lineHeight: "20px",
    color: "#818999",
    display: "flex",
    alignItems: "flex-end",
  },
  vitalValueText: {
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "21px",
    display: "flex",
    alignItems: "flex-end",
  },

  vitalUnit: {
    fontWeight: 500,
    fontSize: "10px",
    lineHeight: "20px",
    color: "#474E5B",
    display: "flex",
    alignItems: "flex-end",
  },
  loader: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  chatHeader: {
    backgroundColor: "#1B75BC",
    color: "#fff",
    padding: "10px",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  icons: {
    display: "flex",

    gap: "10px",
  },
  center: {
    display: "flex",
    alignItems: "center",
  },
  icon: {
    cursor: "pointer",
  },
  messagesContainer: {
    padding: "10px",
    flex: 1,

    overflowY: "auto" as "auto",
    // maxHeight: "400px",
  },
  message: {
    marginBottom: "10px",
  },
  timestamp: {
    textAlign: "center" as "center",
    fontSize: "12px",
    color: "#999",
  },
  messageContent: {
    display: "flex" as "flex",
    alignItems: "flex-start" as "flex-start",
  },
  avatar: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    marginRight: "10px",
  },
  sender: {
    fontWeight: "bold" as "bold",
    marginBottom: "5px",
  },
  text: {
    backgroundColor: "#f1f1f1",
    padding: "10px",
    borderRadius: "10px",
  },
  delivered: {
    textAlign: "right" as "right",
    fontSize: "12px",
    color: "#999",
  },
  inputContainer: {
    padding: "10px",
    display: "flex" as "flex",
    alignItems: "center" as "center",
    gap: "16px",
  },
  input: {
    flex: 1,
    padding: "10px",
    borderRadius: "5px",
    // marginRight: "10px",
  },
  alertvitalCard: {
    border: "1px solid #F12222",
    borderRadius: "8px",
    width: "100%",
    height: "100%",
    padding: "8px",
    backgroundColor: "#FFF0F0",
  },
  vitalCard: {
    border: "1px solid #C9CDD3",
    borderRadius: "8px",
    width: "100%",
    height: "100%",
    padding: "8px",
  },
  sendButton: {
    padding: "10px 10px",
    borderRadius: "5px",
    cursor: "pointer" as "pointer",
  },
};

export function ChatWindow({
  patientId,
  practiotnerId,
  name,
  selectedClients,
}: chatProps): JSX.Element {
  const [showChat, setShowChat] = useState(false);

  const toggleChat = () => {
    setShowChat(!showChat);
  };

  return (
    <div>
      <ActionIcon
        radius="xl"
        size="xl"
        onClick={toggleChat}
        style={{
          position: "fixed",
          bottom: "50px",
          right: "40px",
          zIndex: 9999,
          background: "#1c7ed6",
          width: 100,
        }}
      >
        <MessageSquare color="white" />
        <span style={{ color: "white", marginLeft: "5px" }}> Chat </span>
      </ActionIcon>
      {showChat && (
        <ChatWidget
          patientId={patientId}
          practiotnerId={practiotnerId}
          name={name}
          selectedClients={selectedClients}
        />
      )}
    </div>
  );
}
